import {
  checkoutEndpoint,
  checkoutPaymentEndpoint,
  purchaseEndpoint,
  paymentMethodEndpoint,
  cartCouponEndpoint,
  contractEndpoint,
  ordersEndpoint,
  upsellEndpoint,
  checkoutEarlyRenewEndpoint,
  upsellOrderEndpoint,
  renewEndpoint,
} from '../microsservices/CommerceApi';
import { termsOfUseEndpoint, policyEndpoint } from '../microsservices/PubliFilesApi';

import { ICheckout } from '@/interfaces/Checkout';
import { IPurchase } from '@/interfaces/Purchase';

export function checkoutBySlug(slug: string, payload: any, enableHiddenMethods = false, params?: any): Promise<any> {
  return checkoutEndpoint.post<ICheckout>(payload, {
    uriParams: {
      slug
    },
    ...(params && {
      params: {
        ...params,
      },
    }),
  });
}

export function checkoutPaymentBySlug(slug: string, payload: any, enableHiddenMethods = false, params?: any): Promise<any> {
  return checkoutPaymentEndpoint.post<ICheckout>(payload, {
    uriParams: {
      slug
    },
    ...(params && {
      params: {
        ...params,
      },
    }),
    ...(enableHiddenMethods && {
      params: {
        enableHiddenPaymentMethods: true
      }
    })
  });
}

export function checkoutEarlyRenew(contractId: string, params?: any, enableHiddenMethods = false): Promise<any> {
  const payload = {
    ...params,
    ...(enableHiddenMethods && {
      custom_payment_parameters: {
        enableHiddenPaymentMethods: true
      }
    })
  };

  return checkoutEarlyRenewEndpoint.post<ICheckout>(payload, {
    uriParams: {
      contractId
    },
  });
}

export function changePaymentMethod(cartId: string, payload: { payment_condition_selected: string | null | number }): Promise<any> {
  return paymentMethodEndpoint.patch<ICheckout>(payload, {
    uriParams: {
      cartId
    }
  });
}

export function applyOfferCoupon(cartId: string, payload: { coupon: string | null }): Promise<any> {
  return cartCouponEndpoint.patch<ICheckout>(payload, {
    uriParams: {
      cartId
    }
  });
}

export function buy(purchasePayload: IPurchase): Promise<any> {
  return purchaseEndpoint.post(purchasePayload);
}

export function buyUpsell(orderId: string | number, payload: IPurchase, params: any): Promise<any> {
  const newParams = params.reduce((obj: any, param: any) => ({ ...obj, [param.key]: param.value }), {});

  return purchaseEndpoint.post(payload, {
    params: {
      ...newParams,
      orderId,
    },
  });
}

export function renew(purchasePayload: IPurchase): Promise<any> {
  return renewEndpoint.post(purchasePayload);
}

export function renewUpsell(orderId: string | number, payload: IPurchase, params: any): Promise<any> {
  const newParams = params.reduce((obj: any, param: any) => ({ ...obj, [param.key]: param.value }), {});

  return renewEndpoint.post(payload, {
    params: {
      ...newParams,
      orderId,
    },
  });
}

export function fetchOrder(orderId: any): Promise<any> {
  return ordersEndpoint.get({
    uriParams: {
      orderId
    }
  });
}

export function fetchUpsell(orderId: any, params: any = {}): Promise<any> {
  return upsellEndpoint.get({
    params,
    uriParams: {
      orderId
    }
  });
}

export function getUpsellCart(payload: any): Promise<any> {
  const { params, uriParams } = payload;

  return upsellOrderEndpoint.post(params, { uriParams });
}

export function getContractById(contractId: string | number): Promise<any> {
  return contractEndpoint.get({
    uriParams: {
      contractId,
    },
  });
}

export function getTermsOfUse(): Promise<any> {
  return termsOfUseEndpoint.get();
}

export function getPolicy(): Promise<any> {
  return policyEndpoint.get();
}
